import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import './inform.scss';

Inform.propTypes = {
		param1: PropTypes.bool,
		param2: PropTypes.bool,
		param3: PropTypes.bool,
		param4: PropTypes.bool,
		param5: PropTypes.bool,
		onClick1: PropTypes.object,
		onClick2: PropTypes.object,
		onClick3: PropTypes.object,
		onClick4: PropTypes.object,
		onClick5: PropTypes.object    
	};

	Inform.defaultProps = {
		param1: false,
		param2: false,
		param3: false,
		param4: false,
		param5: false,
		onClick1: ()=>{},
		onClick2: ()=>{},
		onClick3: ()=>{},
		onClick4: ()=>{},
		onClick5: ()=>{}
	};

const InfoTextGray = (props) => {
		return <div onClick={ props.onClick || {} } className={`inform-text-color ${props.className || ""}`}>
				{ props.children }
		</div>
}

function Inform(props){

		useEffect(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' });
		});

		const { param1, param2, param3, param4, onClick1, onClick2, onClick3, onClick4, onClick5 } = props
		
		return(
				<>
						<InfoTextGray className={param1?"inform-font-bold":""} onClick={ onClick1 }>Como funciona o Teste do Covid?</InfoTextGray>
						<InfoTextGray className={param2?"inform-font-bold":""} onClick={ onClick2 }>Qual teste devo fazer?</InfoTextGray>
						<InfoTextGray className={param3?"inform-font-bold":""} onClick={ onClick3 }>A partir de qual idade pode</InfoTextGray>
						<InfoTextGray className={param3?"inform-font-bold":""} onClick={ onClick3 }>fazer o Teste?</InfoTextGray>
						<InfoTextGray className={param4?"inform-font-bold":""} onClick={ onClick4 }>Mais informações</InfoTextGray>           

						<br/>
						<Button label="Cancelar Agenda" className="Primary p-button-rounded button-blue button-width" onClick={ onClick5 }
						/>   
						<br/><br/>
						<strong className="info-font-size"><mark className="info-mark-color">Para mais<br/>informações,<br/>ligue:</mark></strong>
						<br/><br/>
						<label>0800 771 2120</label>
						<br/><br/>
						<strong className="info-font-size"><mark className="info-mark-color">WhatsApp:</mark></strong>
						<br/><br/>
						<label style={{fontSize:'17px'}}>19 99665 6232</label>
				</>
		)
}

export default Inform